import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.893 2.398a1.6 1.6 0 0 1 1.589 1.413l.011.187v16a1.6 1.6 0 0 1-1.413 1.59l-.187.01h-16a1.6 1.6 0 0 1-1.589-1.412l-.011-.188v-16A1.6 1.6 0 0 1 4.706 2.41l.187-.012h16Zm0 1.6h-16v16h16v-16ZM15.68 9.806c2.403 0 2.848 1.581 2.848 3.637l-.003 4.187h-2.368l-.005-4.032c-.016-.816-.157-1.704-1.23-1.704-1.157 0-1.395.848-1.421 1.775l-.003 3.961h-2.37V9.998h2.275v1.04h.032a2.496 2.496 0 0 1 2.245-1.232Zm-6.041.19v7.634H7.264V9.997H9.64ZM8.453 6.203a1.376 1.376 0 1 1 0 2.752 1.376 1.376 0 0 1 0-2.752Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
